import { AxiosInstance } from 'axios';
import { HealthCheckRepository } from '@/model/repository/manager/dailyCheck/healthCheck/repository';
import { fetchWithKeepAlive } from '@/repository/manager/fetch';
import { serializeTopicsRequestParams } from '@/repository/manager/topics/serializeTopicsRequestParams';

export default (axios: AxiosInstance) =>
  (resource: string): HealthCheckRepository => ({
    search(params) {
      // search_id[] などの配列パラメータを AngularJS $http 互換（key[]=v1&key[]=v2）で直列化する
      return axios.get(`${resource}`, { params, paramsSerializer: serializeTopicsRequestParams });
    },
    post(payload) {
      return axios.post(`${resource}`, payload);
    },
    put({ id, ...body }) {
      return axios.put(`${resource}/${id}`, body);
    },
    postWithKeepAlive(payload) {
      return fetchWithKeepAlive(`${resource}?__env__=mgr&keepAlive=true`, 'POST', payload);
    },
    putWithKeepAlive({ id, ...body }) {
      return fetchWithKeepAlive(`${resource}/${id}?__env__=mgr&keepAlive=true`, 'PUT', body);
    },
  });
